import React from 'react'
import { AuthorImage, GuestAuthorTag } from '../../../atoms'
import { removeWhitespaceAndSpecialChars } from '../../helpers/commons'

interface QuoteDetails {
  title: string
  quote: string
  imgUrl: string
  authorName: string
  authorDesg: string
  authorUrl: string
  companyLogoUrl: string
}

interface AuthorSnippetWithTitleProps {
  name: string
  jsonBody: QuoteDetails
}

const AuthorSnippetWithTitle = ({ jsonBody, name }: AuthorSnippetWithTitleProps) => {
  try {
    return (
      <div className='author-snippet-with-title' id={removeWhitespaceAndSpecialChars(name)}>
        <div className='author-snippet-with-title__content'>
          <div className='author-snippet-with-title__content__title'>
            <h2>{jsonBody.title}</h2>
          </div>
          <div className='author-snippet-with-title__content__quote'>
            <span className='author-snippet-with-title__content__quote__text'>
              “{jsonBody.quote}”
            </span>
          </div>
          <div className='author-snippet-with-title__content__author'>
            <div className='author-snippet-with-title__content__author__details'>
              <div className='author-snippet-with-title__content__author__details__mask'>
                <AuthorImage src={jsonBody.imgUrl} variant='small' />
              </div>
              <div className='author-snippet-with-title__content__author__details__text'>
                <div className='author-snippet-with-title__content__author__details__text__name-tag'>
                  <a
                    className='author-snippet-with-title__content__author__details__text__name-tag__name'
                    href={jsonBody.authorUrl}
                  >
                    {jsonBody.authorName}
                    <span className='author-snippet-with-title__content__author__details__text__name-tag__name__dash'>
                      -
                    </span>
                  </a>
                  <div className='author-snippet-with-title__content__author__details__text__name-tag__tag'>
                    {jsonBody.companyLogoUrl && (
                      <GuestAuthorTag companyLogoUrl={jsonBody.companyLogoUrl} />
                    )}
                  </div>
                </div>
                <div className='author-snippet-with-title__content__author__details__text__designation'>
                  {jsonBody.authorDesg}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  } catch (error) {
    return <></>
  }
}

export default AuthorSnippetWithTitle
